export const countryInfoMap: Record<
  string,
  { name: string; currency: string }
> = {
  MX: { name: 'Mexico', currency: 'Mexican Pesos' },
  CA: { name: 'Canada', currency: 'Canadian Dollars' },
  SG: { name: 'Singapore', currency: 'Singaporean Dollars' },
  AU: { name: 'Australia', currency: 'Australian Dollars' },
  GB: { name: 'United Kingdom', currency: 'British Pounds' },
  IT: { name: 'Italy', currency: 'Euros' },
  FR: { name: 'France', currency: 'Euros' },
  DE: { name: 'Germany', currency: 'Euros' },
  ES: { name: 'Spain', currency: 'Euros' },
  AT: { name: 'Austria', currency: 'Euros' },
  NL: { name: 'Netherlands', currency: 'Euros' },
  BE: { name: 'Belgium', currency: 'Euros' },
  CY: { name: 'Cyprus', currency: 'Euros' },
  LV: { name: 'Latvia', currency: 'Euros' },
  LT: { name: 'Lithuania', currency: 'Euros' },
  IE: { name: 'Ireland', currency: 'Euros' },
  PT: { name: 'Portugal', currency: 'Euros' },
  SI: { name: 'Slovenia', currency: 'Euros' },
  SK: { name: 'Slovakia', currency: 'Euros' },
  MT: { name: 'Malta', currency: 'Euros' },
  GR: { name: 'Greece', currency: 'Euros' },
  FI: { name: 'Finland', currency: 'Euros' },
  EE: { name: 'Estonia', currency: 'Euros' },
  LU: { name: 'Luxembourg', currency: 'Euros' },
};
